import {formateData, headers,post} from "./index";
import {applicationName} from "../utils";
import request from "../base/request";

export const getStorageDirectoryList = (storageDirectoryId, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/storage/storageList";
    request({
        url,method:"post",body:{storageDirectoryId},callBack
    });
};
export const getAllParent = (directoryId, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/getAllParent";
    request({
        url,method:"post",body:{directoryId},callBack
    });
};

export const createStorageDirectory = (name, fid, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/createStorageDirectory";
    request({
        url,method:"post",body:{name, fid},callBack
    });
};

export const storageDirectoryRename = (storageDirectoryId, name, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/storageDirectoryRename";
    request({
        url,method:"post",body:{storageDirectoryId},callBack
    });
};
export const storageFileRename = (md5, name, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/storageFileRename";
    request({
        url,method:"post",body:{md5, name},callBack
    });
};
export const fileToDirectory = (md5, directoryId, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/fileToDirectory";
    request({
        url,method:"post",body:{directoryId, md5},callBack
    });
};
export const filesToDirectory = (md5s, directoryId, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/filesToDirectory";
    request({
        url,method:"post",body:{directoryId, md5s},callBack
    });
};
export const search = (searchStr, directoryId, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/search";
    request({
        url,method:"post",body:{searchStr, directoryId},callBack
    });
};

export const batchDownload = (directoryIds, fileIds) => {
    let url = "/cm-sites-" + applicationName() + "/storage/batchDownload";
    request({
        url,method:"downloadPost",body:{directoryIds, fileIds}
    });
};

export const moveToRecycle = (directoryIds, fileIds, fileMd5s, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/moveToRecycle";
    request({
        url,method:"post",body:{directoryIds, fileIds, fileMd5s},callBack
    });
};
export const moveByDirectoryIdsAndFileIds = (directoryIds, fileIds, targetId, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/moveByDirectoryIdsAndFileIds";
    request({
        url,method:"post",body:{directoryIds, fileIds, targetId},callBack
    });
};
export const recover = (directoryIds, fileIds, targetId, fileMd5s, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/recover";
    request({
        url,method:"post",body:{directoryIds, fileIds, targetId, fileMd5s},callBack
    });
};
export const deleteByDirectoryIdsAndFileIds = (directoryIds, fileIds, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/deleteByDirectoryIdsAndFileIds";
    request({
        url,method:"post",body:{directoryIds, fileIds},callBack
    });
};


export const getByPath = (path, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/resource/getByPath";
    request({
        url,method:"post",body:{path},callBack
    });
};

export const  getPictureInfosByPath=(param,callBack)=>{
    let url = "/cm-sites-" + applicationName() + "/resource/getPictureInfosByPath";
    request({
        url,method:"post",body:param,callBack
    });
};

export const getByMd5s = (md5s, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/resource/getByMd5s";
    request({
        url,method:"post",body:{md5s},callBack
    });
};

export const addLabel = (directoryIds, md5s, labelsParam, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/addLabel";
    request({
        url,method:"post",body:{directoryIds, md5s, labelsParam},callBack
    });
};

export const getStorageDirectory = (storageDirectoryId, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/getStorageDirectory";
    request({
        url,method:"post",body:{storageDirectoryId},callBack
    });
};

export const setDirectoryLabels = (directoryId, labels, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/setDirectoryLabels";
    request({
        url,method:"post",body:{directoryId, labels},callBack
    });
};

export const fileToDirectoryAndAddLabel = (md5s, directoryId, labelsParam, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/fileToDirectoryAndAddLabel";
    request({
        url,method:"post",body:{md5s, directoryId, labelsParam},callBack
    });
};

export const addRelatedDeptIds = (md5s, directoryIdsParam, relatedDeptIds, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storage/addRelatedDeptIds";
    request({
        url,method:"post",body:{md5s, directoryIdsParam, relatedDeptIds},callBack
    });
};
export const getDirDynamicAttribute = (dirId,callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/v3/zyk/getDirDynamicAttribute";
    request({
        url,method:"get",body:{dirId},callBack
    });
};




